import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { quizModel } from '../../../Interfaces/quizModel';
import { quizQuestionModel } from '../../../Interfaces/quizQuestionModel';
import QuizView from './QuizView';
import Loader from '../../../Helper/Loader';
function QuizPage() {
  const [userId, setUserId] = useState("");
  const[loading, setLoading] =useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { quizQuestionResult: quizModel } | undefined;
  const quizQuestionData = state?.quizQuestionResult;
  const[getQuestionRes, setGetQuestionRes] = useState<quizQuestionModel[]>([]);
  const[getLevel, setGetLevel] = useState({
    itemQuestions:0,
    quizLevel :0,
  });
 // console.log(quizQuestionData);
 useEffect(() =>{
  setLoading(true);
  if(!quizQuestionData){
    navigate("/startquiz/quiz/continue");
  }else{
    if(quizQuestionData?.quizQuestions != null){
      setUserId(quizQuestionData.userId);
      setGetQuestionRes(quizQuestionData.quizQuestions)
      setGetLevel( prev => ({
          ...prev,
          itemQuestions:quizQuestionData.itemQuestions,
          quizLevel:quizQuestionData.quizLevel,
      }))
    }
  }
  setLoading(false);
 },[quizQuestionData])
 

  return (
    <div>
       {!loading && <QuizView questions={getQuestionRes} userId={userId} getLevel={getLevel}/> }
        {loading && <Loader/>} 
    </div>
  )
}

export default QuizPage